import React from "react";

export type InvertBoxProps = {
  children?: React.ReactNode;
};

export const InvertBox = ({ children }: InvertBoxProps) => {
  return <div className="gpc__invert-box">{children}</div>;
};

export default InvertBox;
